/**
 * Created by Claude on 08.03.2026
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ISLAND_DECORATION_TITLE: {
        size: 70,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.ISLAND_DECORATION_STROKE
    },

    ISLAND_DECORATION_STAGE_TITLE: {
        size: 40,
        stroke: cleverapps.styles.DECORATORS.DARK_BLUE_STROKE
    },

    ISLAND_DECORATION_STAGE_REWARDS: {
        size: 44
    },

    ISLAND_DECORATION_ITEM_TITLE: {
        size: 36,
        color: cleverapps.styles.COLORS.ISLAND_DECORATION_ITEM
    },

    ISLAND_DECORATION_ITEM_PRICE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    ISLAND_DECORATION_TIMER: {
        size: 50,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    ISLAND_DECORATION_PROGRESSBAR: {
        name: "default",
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    ISLAND_PREVIEW_TITLE_DESCRIPTION: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW
    },
    ISLAND_PREVIEW_TITLE_DESCRIPTION_VERTICAL: {
        size: 54,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW
    }
});
